module.exports = __webpack_public_path__ + "img/tablet.e779a595.png";